import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { OfferingCardLane } from '@ole-ui/ole-ui-components';
import useMobxStores from 'hooks/useMobxStores';
import { SkillsAssessmentCard } from 'components/OfferingCards';
import { SKILLS_ASSESSMENT_URL } from 'config/constants';
import { SkillsAssessment } from 'services/SkillsAssessmentService';
import { CommonLaneProps } from './types';

function compareByTimestampDescending(
  first: SkillsAssessment,
  second: SkillsAssessment,
): number {
  return (
    new Date(second.timestamp).getTime() - new Date(first.timestamp).getTime()
  );
}

const SkillsAssessmentsLane = ({ expanded, onTitleClick }: CommonLaneProps) => {
  const { t } = useTranslation();
  const { catalogStore } = useMobxStores();

  const sortedAssessments = catalogStore.skillsAssessments
    .slice()
    .sort(compareByTimestampDescending);

  return (
    <OfferingCardLane
      className="new_lane"
      emptyMessage={
        <p className="empty-message">
          {t('You have no Skills Assessments.')}{' '}
          <a
            href={`${SKILLS_ASSESSMENT_URL}/en`}
            rel="noreferrer"
            target="_blank"
          >
            {t('Complete a Skills Assessment')}
          </a>
        </p>
      }
      expanded={expanded}
      items={sortedAssessments}
      maxItems={25}
      onTitleClick={onTitleClick}
      renderItem={(assessment) => <SkillsAssessmentCard {...assessment} />}
      title={t('Skills Assessments')}
    />
  );
};

export default observer(SkillsAssessmentsLane);
